import { EHelpFileEndpoint } from '../../../services/HelpMenu';
import { ISearchResult } from '@gerdau/hefesto/SearchField/SearchField.types';

export interface IHelpItem {
  title: string;
  endpoint: EHelpFileEndpoint;
  taggingItemDescription: string;
}

// Action Types
export enum Types {
  LOAD_HELPCENTER = 'helpcenter/LOAD_HELPCENTER',
  LOAD_HELPCENTER_SUCCESS = 'helpcenter/LOAD_HELPCENTER_SUCCESS',
  LOAD_HELPCENTER_FAILURE = 'helpcenter/LOAD_HELPCENTER_FAILURE',

  LOAD_HELPCENTER_QUERY = 'helpcenter/LOAD_HELPCENTER_QUERY',
  LOAD_HELPCENTER_QUERY_SUCCESS = 'helpcenter/LOAD_HELPCENTER_QUERY_SUCCESS',
  LOAD_HELPCENTER_QUERY_FAILURE = 'helpcenter/LOAD_HELPCENTER_QUERY_FAILURE',
  LOAD_HELPCENTER_QUERY_CLEAN = 'helpcenter/LOAD_HELPCENTER_QUERY_CLEAN',
  LOAD_HELPCENTER_QUERY_TOPICS_SUCCESS = 'helpcenter/LOAD_HELPCENTER_QUERY_TOPICS_SUCCESS',

  LOAD_HELPCENTER_SUGGESTION = 'helpcenter/LOAD_HELPCENTER_SUGGESTION',
  LOAD_HELPCENTER_SUGGESTION_SUCCESS = 'helpcenter/LOAD_HELPCENTER_SUGGESTION_SUCCESS',
  LOAD_HELPCENTER_SUGGESTION_FAILURE = 'helpcenter/LOAD_HELPCENTER_SUGGESTION_FAILURE',

  LOAD_HELPCENTER_CATEGORIES = 'helpcenter/LOAD_HELPCENTER_CATEGORIES',
  LOAD_HELPCENTER_CATEGORIES_SUCCESS = 'helpcenter/LOAD_HELPCENTER_CATEGORIES_SUCCESS',
  LOAD_HELPCENTER_CATEGORIES_FAILURE = 'helpcenter/LOAD_HELPCENTER_CATEGORIES_FAILURE',

  LOAD_HELPCENTER_TOPICS = 'helpcenter/LOAD_HELPCENTER_TOPICS',
  LOAD_HELPCENTER_TOPICS_SUCCESS = 'helpcenter/LOAD_HELPCENTER_TOPICS_SUCCESS',
  LOAD_HELPCENTER_TOPICS_FAILURE = 'helpcenter/LOAD_HELPCENTER_TOPICS_FAILURE'
}

export interface FAQProps {
  categories: CategorySource[];
  question: QuestionLikeSource[];
  query: {
    searchTerm: string;
    results: QuestionLikeSource[];
  };
  suggestions: ISearchResult[];
}

export const USER_ACESS_TYPE = {
  CORTE_E_DOBRA: 'corte-e-dobra',
  COMMERCE_MAGENTO: 'commerce-magento',
  DEFAULT: 'default'
} as const;

export type IUserAcess = (typeof USER_ACESS_TYPE)[keyof typeof USER_ACESS_TYPE];

export type FAQSources = QuestionLikeSource | CategorySource;

export interface IHelpCenter {
  loading: boolean;

  error: boolean;
  errorMessage?: string;

  initialized: boolean;

  faq: FAQProps;

  commerce: IHelpCenterCommerce;
}

export interface IHelpCenterCommerce {
  categories: HelpCenterCategory[];
  topicsByCategory: Record<number, HelpCenterTopic[]>;
  searchResults: HelpCenterTopic[];
  loadingCategories: boolean;
  loadingTopics: boolean;
  error: boolean;
}

export type HelpCenterListResponse<T> = {
  items: T[];
  total_count: number;
};

export type HelpCenterCategory = {
  category_id: number;
  name: string;
  description: string;
  identifier: string;
  is_active: boolean;
  sort_order: number;
  store_ids: number[];
  created_at: string;
  updated_at: string;
};

export type HelpCenterTopicType = 'question' | 'manual';

export type HelpCenterTopic = {
  id: number;
  type: HelpCenterTopicType;
  title: string;
  description: string;
  file: string;
  category_id: number;
  meta_keywords: string;
  active: boolean;
  order: number;
  extension_attributes: any;
};

export type HitsSource = {
  _index: string;
  _id: string;
  _score: number;
  _source: QuestionLikeSource | CategorySource;
};

export type OpenSearchResponse = {
  took: number;
  timed_out: boolean;
  _shards: {
    total: number;
    successful: number;
    skipped: number;
    failed: number;
  };
  hits: {
    total: {
      value: number;
      relation: string;
    };
    max_score: number;
    hits: HitsSource[];
  };
  suggest?: Suggest;
};

export type AttachmentsHelpCenterType = {
  name: string;
  file: string;
};

export type QuestionLikeSource = {
  type: 'question' | 'query';
  question: string;
  answer: string;
  attachments: AttachmentsHelpCenterType[];
  keywords: IUserAcess[];
  categories: string[];
};

export type CategorySource = {
  type: 'category';
  title: string;
  description: string;
  attachments: AttachmentsHelpCenterType[];
  keywords: IUserAcess[];
  id: string;
};

type SuggestOption = {
  text: string;
  score: number;
  freq: number;
};

type SuggestEntry = {
  text: string;
  offset: number;
  length: number;
  options: SuggestOption[];
};

type Suggest = {
  did_you_mean: SuggestEntry[];
};

export type FaqSearchResponse = OpenSearchResponse;
